import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "account_id": {
      "column": {
        "default": null,
        "name": "account_id",
        "null": false,
        "type": null
      },
      "name": "account_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "school_id": {
      "column": {
        "default": null,
        "name": "school_id",
        "null": false,
        "type": null
      },
      "name": "school_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "AccountSchool",
  "collectionKey": "account_schools",
  "collectionName": "account_schools",
  "i18nKey": "account_school",
  "camelizedLower": "accountSchool",
  "name": "AccountSchool",
  "nameDasherized": "account-school",
  "pluralName": "account_schools",
  "ransackable_associations": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "account",
      "macro": "belongs_to",
      "resource_name": "Account",
      "through": null
    },
    {
      "className": "AccountSchool::Audit",
      "collectionName": "account_school_audits",
      "foreignKey": "account_school_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "AccountSchoolAudit",
      "through": null
    },
    {
      "className": "AccountSchool::Audit",
      "collectionName": "account_school_audits",
      "foreignKey": "account_school_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "AccountSchoolAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "account_id",
      "column": {
        "default": null,
        "name": "account_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "school_id",
      "column": {
        "default": null,
        "name": "school_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "account",
      "macro": "belongs_to",
      "resource_name": "Account",
      "through": null
    },
    {
      "className": "AccountSchool::Audit",
      "collectionName": "account_school_audits",
      "foreignKey": "account_school_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "AccountSchoolAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    }
  ],
  "paramKey": "account_school",
  "primaryKey": "id"
}

/** Frontend model for AccountSchool. */
class AccountSchool extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  accountId() {
    return this.readAttributeUnderscore("account_id")
  }

  /** @returns {boolean} */
  hasAccountId() {
    const value = this.accountId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  schoolId() {
    return this.readAttributeUnderscore("school_id")
  }

  /** @returns {boolean} */
  hasSchoolId() {
    const value = this.schoolId()

    return this._isPresent(value)
  }

  /** @returns {import("./account.js").default | null} */
  account() {
    return this._readBelongsToReflection({reflectionName: "account"})
  }

  /** @returns {Promise<import("./account.js").default | null>} */
  loadAccount() {
    if (!("accountId" in this)) throw new Error("Foreign key method wasn't defined: accountId")

    const id = this.accountId()
    const modelClass = modelClassRequire("Account")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "account", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./account-school-audit.js").default | null} */
  createAudit() {
    return this._readHasOneReflection({reflectionName: "create_audit"})
  }

  /** @returns {Promise<import("./account-school-audit.js").default | null>} */
  loadCreateAudit() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const modelClass = modelClassRequire("AccountSchoolAudit")
    const ransack = {}

    ransack["account_school_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "create_audit",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("./school.js").default | null} */
  school() {
    return this._readBelongsToReflection({reflectionName: "school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadSchool() {
    if (!("schoolId" in this)) throw new Error("Foreign key method wasn't defined: schoolId")

    const id = this.schoolId()
    const modelClass = modelClassRequire("School")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "school", model: this, modelClass},
      {ransack}
    )
  }
}

export default AccountSchool
